export const alertDetectionIncludesLineCrossing = (
  alertLabels?: string | string[] | null
): boolean => {
  const labels = Array.isArray(alertLabels)
    ? alertLabels
    : typeof alertLabels === "string"
      ? [alertLabels]
      : [];
  return labels.some((label) =>
    String(label).toLowerCase().replace(/_/g, " ").includes("line crossing")
  );
};

export const handleCreateAlertTypeNoUnderscore = (name?: string | null) => {
  if (typeof name !== "string" || name.length === 0) {
    return "";
  }

  let newName = name.slice(0, 1).toUpperCase() + name.slice(1);
  if (newName.includes("_")) {
    newName = newName.replace(/_/g, " ");
  }
  return newName;
};

export const ALERT_TYPE_STRIPE_COLORS = {
  intruder: "#FF8400",
  vehicle: "#0288D1",
  loiterer: "#7B1FA2",
} as const;

export const ALERT_TYPE_FALLBACK_STRIPE = "#FF8400";

export const getAlertTypeStripeColor = (
  alertLabels?: string | null
): string => {
  const key = (alertLabels || "").toLowerCase().replace(/ /g, "_");
  if (key.includes("vehicle")) return ALERT_TYPE_STRIPE_COLORS.vehicle;
  if (key.includes("loiter")) return ALERT_TYPE_STRIPE_COLORS.loiterer;
  if (key.includes("intruder")) return ALERT_TYPE_STRIPE_COLORS.intruder;
  return ALERT_TYPE_FALLBACK_STRIPE;
};

export const isAlertResolved = (row: {
  detection_type?: string | null;
}): boolean => Boolean(row?.detection_type);

export const countUnresolvedAlerts = (
  rows: { detection_type?: string | null }[]
): number => rows.filter((row) => !isAlertResolved(row)).length;

type FilterDate = string | Date | null | undefined;

// The date filters are Date objects (Alerts.tsx builds them with `new Date`),
// so interpolating them directly printed Date.toString() with the timezone
// name in the condensed header (ENG-1663).
const formatFilterDate = (value: FilterDate): string | undefined => {
  if (value == null || value === "") return undefined;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? undefined : value.toLocaleDateString();
  }
  return value;
};

export const getCondensedWindowLabel = ({
  periodHours,
  userFilters,
}: {
  periodHours: number;
  userFilters?: { start_date?: FilterDate; end_date?: FilterDate };
}): string => {
  const start = formatFilterDate(userFilters?.start_date);
  const end = formatFilterDate(userFilters?.end_date);
  if (start || end) {
    if (start && end) return `${start} – ${end}`;
    if (start) return `From ${start}`;
    return `Through ${end}`;
  }
  if (periodHours === 1) return "Last hour";
  return `Last ${periodHours} hours`;
};
